// Ported verbatim from `sp-shadow-settings`; shared by both signal shadow editors.

function hasExplicitAlpha(color: string): boolean {
    return /^rgba\(/.test(color) || (color.startsWith('#') && color.length === 9);
}

/** The colour's alpha as a percentage — `100` when it carries none. */
export function shadowColorAlpha(color: string): number {
    const rgbaMatch = color.match(/rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(?:,\s*([\d.]+))?\s*\)/);

    if (rgbaMatch) {
        const alpha = rgbaMatch[1] !== undefined ? parseFloat(rgbaMatch[1]) : 1;

        return Math.round(alpha * 100);
    }

    if (color.startsWith('#') && color.length === 9) {
        return Math.round((parseInt(color.slice(7, 9), 16) / 255) * 100);
    }

    return 100;
}

export function withShadowColorAlpha(color: string, alpha: number): string {
    const a = alpha / 100;
    const rgbaMatch = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*[\d.]+)?\s*\)/);

    if (rgbaMatch) {
        return `rgba(${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]}, ${a})`;
    }

    const hex = color.replace('#', '');
    let r: number, g: number, b: number;

    if (hex.length === 3 || hex.length === 4) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else {
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${a})`;
}

/** A picked colour keeps its own alpha; one without keeps the alpha the shadow already had. */
export function pickedShadowColor(picked: string, currentAlpha: number): string {
    if (hasExplicitAlpha(picked)) {
        return picked;
    }

    return currentAlpha < 100 ? withShadowColorAlpha(picked, currentAlpha) : picked;
}
